
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', {
                    'className': 'grid__item grid-product small--one-half medium-up--one-quarter aos-init aos-animate',
                    'data-aos': 'row-of-4'
                }, _createElement('div', { 'className': 'grid-product__content' }, this.out_of_stock ? _createElement('div', {
                    'className': 'grid-product__tag grid-product__tag--sold-out',
                    'key': '160'
                }, '\n      ', _translate(`product_out_of_stock`), '\n    ') : null, _createElement('a', {
                    'href': this.url,
                    'className': 'grid-product__link grid-product__link--disabled'
                }, _createElement('div', { 'className': 'grid-product__image-mask' }, _createElement('div', { 'className': 'grid__image-ratio lazyloaded' }, _createElement('img', {
                    'alt': this.removeHTML(this.title),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'className': 'lazyautosizes lazyloaded',
                    'onError': this.onImageError,
                    'data-sizes': 'auto',
                    'data-parent-fit': 'contain'
                }))), _createElement('div', { 'className': 'grid-product__meta' }, _createElement('div', mergeProps({ 'className': 'grid-product__title grid-product__title--body' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'grid-product__price' }, this.on_sale ? _createElement('div', {
                    'className': 'price_compare',
                    'key': '1010'
                }, this.formatPrice(this.compare_at_price)) : null, _createElement('div', { 'className': 'price' }, this.price_varies ? _createElement('span', { 'key': '1148' }, _translate(`price_from`), ' ') : null, '\n            ', this.formatPrice(this.min_price || this.price), '\n          '))))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []